<template>
  <div class="analytics-webview" style="display: flex; flex-direction: column; gap: 0px;">

    <div class="multiple-filter">

      <div class="flex-container grid grid-nogutter">
        <div class="col">
          <div class="grid grid-nogutter filter-items align-items-center h-full ">
            <div class="w-full">
              <Fieldset class="hidden-legend">
                <div class="grid grid-nogutter filter-items-grouped">
                  <div class="col-5">
                    <Dropdown v-model="quickDatesSelected" :options="quickDates" optionLabel="label"
                      :placeholder="$t('filter_option_lastQuickTime')" class="flex-item-spec-analytics"
                      @update:modelValue="changeQuickDates" />
                  </div>
                  <div class="col-7">
                    <Calendar class="flex-item-spec-analytics" v-model="dateInput" :showButtonBar="false"
                      :showTime="calendarShowTime" :minDate="minDateValue" :maxDate="maxDateValue" :manualInput="false"
                      dateFormat="dd/mm/yy" selectionMode="range" :showIcon="false"
                      :placeholder="$t('appliances_table_header_registrationDate')" @focus="focusCalendar" />
                  </div>
                </div>
              </Fieldset>
            </div>
          </div>
        </div>
        <div class="col-fixed align-items-center justify-content-center flex" style="width: 200px">
          <div v-if="kpiSection" class="filters-list-new">
            <Button icon="pi pi-search appliance-search-button" @click="manageFilters()"
              :label="$t('filter_button_apply')" />
            <Button class="cancel-button" icon="pi pi-times appliance-search-button" @click="clearFiltersValues()"
              :label="$t('filter_button_clear')" />
          </div>
        </div>
        <div style="align-items: center;">
          <Dialog :draggable="false" v-model:visible="visible" modal :header="$t('dialog_error_header')">
            <p>{{ this.$t("dialog_error_content_missingEndDate") }}</p>
          </Dialog>
        </div>
      </div>

    </div>


    <Accordion @tab-click="setKpis" v-if="kpiSection" :multiple="true" v-model:activeIndex="activeAccordions"
      class="mt-3">
      <AccordionTab v-for="accordion in kpiSection.accordions_kpi" :key="accordion.id" :header="$t('analytics_accordions_'+accordion.id)">
        <div class="grid-container">
          <div class="grid-item" v-for="kpi in accordion.kpis" :key="kpi.id">
            <div class="grid-data">
              <div class="header-chart">
                <div class="header-title">{{ $t(kpi.id+"_name") }}</div>
                <div class="header-subtitle">{{ $t(kpi.id+"_subtitle") }}</div>
              </div>
              <div v-if="kpi.loaded">
                <div class="nodata-item" v-if="kpi.chart_series === null && kpi.value === null">
                  <!-- No data -->
                  <p>{{ kpi.desc }}</p>
                </div>
                <div v-else-if="kpi.type_chart == 'stats' && kpi.value !== null" class="stats-chart">
                  <!-- No chart only value -->
                  <p>{{ kpi.value }}</p>
                </div>
                <div v-else class="chart-pie">
                  <!-- With chart -->
                  <apexchart v-if="kpi.chart_series !== null" :options="kpi.chart_options" :series="kpi.chart_series"
                    :type="kpi.type_chart"></apexchart>
                </div>
              </div>
              <div v-else class="body-chart-skeleton">
                <Skeleton width="100%" height="29vh"></Skeleton>
              </div>
            </div>
          </div>
        </div>
      </AccordionTab>
    </Accordion>

  </div>
</template>

<script>
import LoginService from "../service/LoginService";
import AnalyticsService from "../service/AnalyticsService";
import { useAnalyticsStore } from "../stores/charts.js";
import { useLoginStore } from "../stores/login.js";
import { mapState, mapActions } from "pinia";
import axios from "axios";
import { loadMessages } from '../i18n'

export default {
  data() {
    return {
      loginService: null,
      accessToken: this.$route.query.accessToken,
      applianceId: this.$route.params.id,
      type: this.$route.params.type,
      tenant: "smeg",
      kpiSection: null,
      activeAccordions: [0],
      dateInput: null,
      maxDateValue: new Date(),
      // minDateValue: this.$moment(new Date()).subtract(2, "months").startOf('month').toDate(),
      minDateValue: this.$moment(new Date()).subtract(90, "days").toDate(),
      visible: false,
      quickDates: [{
        label: this.$t('filter_option_lastQuickTime_1h'),
        value: [this.$moment().subtract(1, "hours").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_24h'),
        value: [this.$moment().subtract(1, "days").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_48h'),
        value: [this.$moment().subtract(2, "days").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_7d'),
        value: [this.$moment().subtract(7, "days").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_30d'),
        value: [this.$moment().subtract(30, "days").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_90d'),
        value: [this.$moment().subtract(90, "days").toDate(), new Date()]
      }
      ],
      quickDatesSelected: null,
      calendarShowTime: true,
    }
  },
  computed: {
    ...mapState(useLoginStore, ["getSource"]),
  },
  watch: {
    '$i18n.locale': 'setupLocalization'
  },
  created() {
    this.loginService = new LoginService();
    this.analyticsService = new AnalyticsService();

    const CancelToken = axios.CancelToken;
    this.setSource(CancelToken.source());
  },
  async mounted() {
    const messages = await loadMessages(this.$i18n.locale, this.tenant);
    this.$i18n.setLocaleMessage(this.$i18n.locale, messages);
    this.setupLocalization();
    this.quickDatesSelected = this.quickDates[3];
    this.dateInput = this.quickDates[3].value;

    if (this.$moment(this.minDateValue).isBefore(this.$moment('2024-09-03'))) {
      this.minDateValue = this.$moment('2024-09-03').toDate();
    }

    // console.log("route", this.$route);
    this.loginService.abacOnTenant(this.accessToken, this.tenant).then((response) => {
      this.kpiSection = response.role_def.single_device_analytics[this.type];
      this.populateCharts(0)
    });
  },
  beforeUnmount() {
    this.kpiSection = null;
  },
  methods: {
    ...mapActions(useAnalyticsStore, ["getBarChartOptions", "getPieChartOptions", "getLineChartOptions"]),
    ...mapActions(useLoginStore, ["setSource"]),
    manageFilters() {
      this.cancelSource();
      var dosearch = false;

      if (this.dateInput && this.dateInput[0] && this.dateInput[1]) {
        dosearch = true;
      } else {
        this.visible = true;
      }
      if (dosearch) {
        this.kpiSection.accordions_kpi.forEach(
          (acc) => (acc.called = false)
        );
        if (this.kpiSection.accordions_kpi) {
          this.activeAccordions.forEach(activeAcc => {
            this.populateCharts(activeAcc);
          });
        }
      }
    },

    changeQuickDates() {
      this.dateInput = this.quickDatesSelected.value;
      // this.calendarShowTime = true;
    },

    focusCalendar() {
      this.quickDatesSelected = null;
      // this.calendarShowTime = false;
    },


    clearFiltersValues() {
      this.cancelSource();
      this.quickDatesSelected = this.quickDates[3];
      this.dateInput = this.quickDates[3].value;
      this.manageFilters();
    },
    setKpis(event) {
      let activeAccordionsKpis =
        this.kpiSection.accordions_kpi[event.index];
      if (!activeAccordionsKpis.called) {
        this.populateCharts(event.index);
      }
    },
    populateCharts(indexAcc) {
      let accordionTabKpis = this.kpiSection.accordions_kpi[indexAcc];

      this.kpiSection.accordions_kpi[indexAcc].called = true;

      accordionTabKpis.kpis.forEach((kpi, indexKpi) => {
        this.kpiSection.accordions_kpi[indexAcc].kpis[indexKpi].loaded = false;

        var filtersReq = [];

        if (this.statusFilter?.selected_value && this.searchStatus && this.statusOperatorSelected) {
          let filterreq = {
            "field": this.statusFilter.selected_value.code,
            "value": this.searchStatus,
            "operator": this.statusOperatorSelected.code
          };
          filtersReq.push(filterreq);
        }

        // let start_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[0]).startOf('day').toDate());
        // let end_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[1]).endOf('day').toDate());
        // if(this.quickDatesSelected) {
        //     start_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[0]).toDate());
        //     end_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[1]).toDate());
        // }
        let start_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[0]).toDate());
        let end_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[1]).toDate());

        let reqChart = {
          kpi: kpi.id,
          startDate: start_utc.getTime(),
          endDate: end_utc.getTime(),
          filters: filtersReq
        };
        this.getChartById(
          reqChart,
          indexAcc,
          indexKpi
        );
      });
    },
    getChartById(reqChart, indexAccordion, indexKpi) {
      const MISSING_DATA = this.$t("error_missingData");
      this.analyticsService
        .getChartByKPISingleApplianceOnTenant(this.accessToken, reqChart, this.applianceId, this.tenant)
        .then((chart) => {
          let kpi = this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi];
          if (chart.x?.length > 0 && chart.y?.length > 0) {
            let typeChart = kpi.type_chart_name;
            if (typeChart == "stats") {
              kpi.value = chart.y[0];
            } else if (typeChart == "bar") {
              kpi.chart_options = this.getBarChartOptions(chart);
              kpi.chart_series = [{ name: "Occurrences", data: chart.y }];
            } else if (typeChart == "pie") {
              kpi.chart_options = this.getPieChartOptions(chart);
              kpi.chart_series = chart.y;
            } else if (typeChart == "line") {
              kpi.chart_options = this.getLineChartOptions(chart);
              let lineSeries = [
                {
                  name: "",
                  data: chart.y,
                },
              ];
              kpi.chart_series = lineSeries;
            }
            /* ------------LINECHART-STEPLINE-------------*/
            else if (typeChart == "linechart-stepline") {
              let lineOptions = this.getLineChartOptions(chart);
              lineOptions.xaxis = { categories: chart.x, type: "datetime" };
              lineOptions.stroke = { curve: 'stepline', width: 5 };
              kpi.chart_options = lineOptions;

              let lineSeries = [
                {
                  name: "",
                  data: chart.y,
                },
              ];
              kpi.chart_series = lineSeries;
            }
            /* ------------2 LINE-------------*/
            else if (typeChart == "2-multiline") {
              let lineOptions = this.getLineChartOptions(chart);
              lineOptions.xaxis = { categories: chart.x, type: "datetime" };
              lineOptions.stroke = { width: 5 };
              kpi.chart_options = lineOptions;

              let lineSeries = [
                {
                  name: "",
                  data: chart.y[0],
                },
                {
                  name: "",
                  data: chart.y[1],
                }
              ];
              kpi.chart_series = lineSeries;
            }
            kpi.loaded = true;

          } else {
            // kpi.type_chart == null;
            kpi.desc = MISSING_DATA;
            kpi.loaded = true;
            kpi.chart_series = null;
            kpi.value = null;
          }
        })
        .catch((error) => {
          console.error("EXCEPTION " + error);
          // this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].type_chart == null;
          this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].desc = MISSING_DATA;
          this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].loaded = true;
          this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].chart_series = null;
          this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].value = null;
        });
    },
    cancelSource() {
      this.getSource.cancel('Operation canceled by the user.');
      // console.log("FETCH CANCELED");
      const CancelToken = axios.CancelToken;
      this.setSource(CancelToken.source());
    },
    setupLocalization() {
      this.quickDates = [{
        label: this.$t('filter_option_lastQuickTime_1h'),
        value: [this.$moment().subtract(1, "hours").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_24h'),
        value: [this.$moment().subtract(1, "days").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_48h'),
        value: [this.$moment().subtract(2, "days").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_7d'),
        value: [this.$moment().subtract(7, "days").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_30d'),
        value: [this.$moment().subtract(30, "days").toDate(), new Date()]
      },
      {
        label: this.$t('filter_option_lastQuickTime_90d'),
        value: [this.$moment().subtract(90, "days").toDate(), new Date()]
      }
      ];
    }
  }
}
</script>
